import { createAction } from '@reduxjs/toolkit'

export enum Field {
  INPUT = 'INPUT',
  OUTPUT = 'OUTPUT',
}

export enum DESTINATION_TYPE {
  DESTINATION_LPS = 'DESTINATION_LPS',
  DESTINATION_FARMS = 'DESTINATION_FARMS',
}

export enum ZapInState {
  NONE = 'NONE',
  REQUESTED_PERMISSION = 'REQUESTED_PERMISSION',
  CONFIRMED_PERMISSION = 'CONFIRMED_PERMISSION',
  REQUESTED_ZAPIN = 'REQUESTED_ZAPIN',
  CONFIRMED_ZAPIN = 'CONFIRMED_ZAPIN',
  FINISHED_ZAPIN = 'FINISHED_ZAPIN',
  REQUEST_FARM_STAKING = 'REQUEST_FARM_STAKING',
  CONFIRMED_FARM_STAKING = 'CONFIRMED_FARM_STAKING',
  FINISHED_FARM_STAKING = 'FINISHED_FARM_STAKING',
}

export const selectCurrency = createAction<{ field: Field; currencyId: string }>('zap/selectCurrency')
export const switchCurrencies = createAction<void>('zap/switchCurrencies')
export const typeInput = createAction<{ field: Field; typedValue: string }>('zap/typeInput')
export const replaceZapState = createAction<{
  field: Field
  typedValue: string
  inputCurrencyId?: string
  outputCurrencyId?: string
  recipient: string | null
}>('zap/replaceZapState')
export const setRecipient = createAction<{ recipient: string | null }>('zap/setRecipient')
export const setDestinationType = createAction<{ destinationType: string | null }>('zap/setDestinationType')
export const setZapInState = createAction<{ zapInState: ZapInState | null }>('zap/setZapInState')
